/**
 * OrigCustOrderCapacity
 * - Tag: 1432
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const OrigCustOrderCapacity = Object.freeze({
    /** Member trading for their own account */
    MemberTradingForTheirOwnAccount: 1,
    /** Clearing Firm trading for its proprietary account */
    ClearingFirmTradingForItsProprietaryAccount: 2,
    /** Member trading for another member */
    MemberTradingForAnotherMember: 3,
    /** All other */
    AllOther: 4,
} as const);

export type OrigCustOrderCapacity = (typeof OrigCustOrderCapacity)[keyof typeof OrigCustOrderCapacity];
